/**
 * Show/hide the filters on the blog listing page
 */
 
import $ from 'jquery';

// Module options
const options = {
	isOpen: false
};

// Cached elements
const $el = {
	button: $('.js-filters-toggle'),
	filters: $('.c-filters'),
	filtersList: $('.c-filters ul')
};

// Module events
export default function init() {
	bindEvents();

	if ($el.filters.hasClass('is-active')) {
		open();
	}
}

// User interactions go here
function bindEvents() {
	$el.button.on('click', () => {
		if (options.isOpen) {
			close();
		} else {
			open();
		}
	});
}

function open() {
	$el.filtersList.slideDown({
		easing: 'easeInOutQuart'
	});
	$el.filters.addClass('is-active');
	options.isOpen = true;
}

function close() {
	$el.filtersList.slideUp({
		easing: 'easeInOutQuart'
	});
	$el.filters.removeClass('is-active');
	options.isOpen = false;
}